import { PromotionRepository, UpdatePromotionInput } from '../../domain/repositories/promotion.repository';
import { PromotionEntity } from '../../domain/entities/promotion.entity';

export class UpdatePromotionUseCase {
  constructor(private readonly promotionRepository: PromotionRepository) {}

  async execute(id: string, input: UpdatePromotionInput): Promise<PromotionEntity> {
    return this.promotionRepository.updatePromotion(id, input);
  }
}
